<div class="tw-w-full tw-h-fit tw-min-w-full tw-max-w-full tw-bg-background">
  <div class="tw-w-full tw-h-fit tw-max-w-screen-xl tw-mx-auto tw-bg-background">
    <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
      <div class="tw-w-full tw-h-fit tw-sticky tw-top-5 tw-bg-transparent tw-z-[999] tw-px-8 md:tw-px-16">
        <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-justify-between tw-items-center tw-bg-secondary tw-border tw-border-white/10 tw-rounded-[10px] tw-gap-2 tw-px-2 md:tw-px-4 tw-py-1">
          <div class="tw-w-fit tw-h-fit tw-flex tw-justify-start tw-items-center">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
          </div>
          <img *ngIf="!menuOpen" (click)="triggerMenu()" class="tw-min-w-8 tw-max-w-8 tw-min-h-8 tw-max-h-8 tw-object-contain tw-cursor-pointer" src="../../../assets/toolbar-menu-icon.svg" />
          <img
            *ngIf="menuOpen"
            (click)="triggerMenu()"
            class="tw-min-w-8 tw-max-w-8 tw-min-h-8 tw-max-h-8 tw-object-contain md:tw-hidden tw-cursor-pointer"
            src="../../../assets/close-light-icon.svg"
          />
          <div *ngIf="menuOpen" class="tw-w-full md:tw-w-fit tw-h-fit tw-flex max-md:tw-flex-col tw-justify-center tw-items-center tw-gap-4 md:tw-gap-6 max-md:tw-my-5">
            <div
              (click)="scrollToSection('home')"
              class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border-b tw-border-b-transparent hover:tw-border-b-primary tw-p-2"
            >
              {{ "home" | translate }}
            </div>
            <div
              (click)="scrollToSection('features')"
              class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border-b tw-border-b-transparent hover:tw-border-b-primary tw-p-2"
            >
              {{ "features" | translate }}
            </div>
            <div
              (click)="scrollToSection('pricing')"
              class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border-b tw-border-b-transparent hover:tw-border-b-primary tw-p-2"
            >
              {{ "pricing" | translate }}
            </div>
            <div
              (click)="scrollToSection('contact-us')"
              class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border-b tw-border-b-transparent hover:tw-border-b-primary tw-p-2"
            >
              {{ "contact-us" | translate }}
            </div>
            <div
              (click)="scrollToSection('faq')"
              class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border-b tw-border-b-transparent hover:tw-border-b-primary tw-p-2"
            >
              {{ "faq" | translate }}
            </div>
          </div>
          <div *ngIf="menuOpen" class="tw-w-full md:tw-w-fit tw-h-full tw-flex max-md:tw-flex-col tw-justify-center tw-items-center tw-gap-2 md:tw-gap-4 tw-py-2 tw-relative">
            <button
              (click)="goToRegister()"
              class="tw-w-full md:tw-w-fit tw-h-fit tw-min-w-[150px] tw-bg-primary tw-font-poppins tw-font-semibold tw-text-xs tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-4 md:tw-py-3"
            >
              {{ "create-an-account" | translate }}
            </button>
            <button
              (click)="goToLogin()"
              class="tw-w-full md:tw-w-fit tw-h-fit tw-min-w-[150px] tw-bg-tertiary tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-rounded-[5px] tw-px-4 tw-py-4 md:tw-py-3"
            >
              {{ "login" | translate }}
            </button>
            <p-dropdown
              class="language-flag-dropdown tw-border tw-border-white tw-rounded-[5px] tw-absolute tw-z-[1000]"
              [options]="languages"
              [(ngModel)]="selectedLanguage"
              [dataKey]="'id'"
              [filter]="false"
              [showClear]="false"
              [placeholder]="'language' | translate"
              (onChange)="setLanguage($event)"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-white">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ selectedOption.flag }}"></span>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ item.flag }}"></span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>

      <div id="home" class="tw-w-full tw-h-fit tw-relative tw-px-8 md:tw-px-16">
        <div class="tw-w-full tw-h-fit tw-mt-16 md:tw-mt-32">
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs md:tw-text-base tw-text-primary tw-text-center tw-mb-5">{{ "we-are-teveni" | translate }}</p>
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-secondary tw-text-center tw-mb-10">
            {{ "home-title" | translate }}
          </p>
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-base md:tw-text-xl tw-text-tertiary tw-text-center md:tw-px-[30%] tw-mb-10">
            {{ "home-description" | translate }}
          </p>
          <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4">
            <button
              (click)="goToDiscover()"
              class="tw-w-full md:tw-w-fit tw-h-fit md:tw-min-w-[250px] tw-bg-primary tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-4"
            >
              {{ "discover" | translate }}
            </button>
            <button
              (click)="goToDelivery()"
              class="tw-w-full md:tw-w-fit tw-h-fit md:tw-min-w-[250px] tw-bg-tertiary tw-font-poppins tw-font-semibold tw-text-sm tw-text-white tw-rounded-[5px] tw-px-4 tw-py-4"
            >
              {{ "get-courier-app" | translate }}
            </button>
          </div>
          <div class="tw-w-full tw-h-fit tw-relative -tw-bottom-14 md:-tw-bottom-28 tw-flex tw-justify-center tw-items-center tw-bg-background tw-rounded-[10px] -tw-mt-4 md:-tw-mt-12">
            <div class="tw-w-full tw-max-w-[400px] md:tw-max-w-[1000px] tw-relative">
              <p-carousel
                [value]="mockups"
                [numVisible]="3"
                [numScroll]="1"
                [responsiveOptions]="mockupsResponsiveOptions"
                [circular]="true"
                [showNavigators]="true"
                [showIndicators]="true"
                [autoplayInterval]="4000"
                styleClass="tw-w-full mockups-carousel"
              >
                <ng-template let-mockup pTemplate="item">
                  <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-items-center">
                    <p class="tw-w-full tw-h-fit tw-font-poppins tw-italic tw-font-normal tw-text-xs tw-text-tertiary tw-text-center">
                      {{ mockup.label | translate }}
                    </p>
                    <img class="tw-w-full tw-h-auto tw-object-contain" [src]="'../../../assets/' + mockup.image" />
                  </div>
                </ng-template>
              </p-carousel>
            </div>
          </div>
        </div>
      </div>

      <div id="features" class="tw-w-full tw-h-fit tw-bg-secondary 2xl:tw-rounded-[10px] tw-px-8 md:tw-px-16 tw-py-20 md:tw-py-40">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs md:tw-text-base tw-text-white tw-text-center tw-mb-5">{{ "features" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-white tw-text-center tw-mb-10">{{ "features-text-1" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-base md:tw-text-xl tw-text-white/50 tw-text-center md:tw-px-[30%] tw-mb-10">
          {{ "features-text-2" | translate }}
        </p>
        <div class="tw-w-full tw-h-fit tw-flex max-md:tw-flex-col tw-justify-center tw-items-center tw-gap-10">
          <div class="tw-w-full md:tw-w-fit tw-h-fit md:tw-max-w-[30%] tw-flex tw-flex-col tw-items-center">
            <img class="tw-w-12 tw-h-12 tw-object-contain tw-mb-5" src="../../../assets/online-store-icon.svg" />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm md:tw-text-lg tw-text-white tw-text-center tw-mb-5">{{ "online-store" | translate }}</p>
            <p class="tw-w-full md:tw-min-h-24 md:tw-max-h-24 tw-font-poppins tw-font-normal tw-text-sm md:tw-text-base tw-text-white/50 tw-text-center">
              {{ "online-store-text-1" | translate }}
            </p>
          </div>
          <div class="tw-w-full md:tw-w-fit tw-h-fit md:tw-max-w-[30%] tw-flex tw-flex-col tw-items-center">
            <img class="tw-w-12 tw-h-12 tw-object-contain tw-mb-5" src="../../../assets/admin-dashboard-icon.svg" />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm md:tw-text-lg tw-text-white tw-text-center tw-mb-5">{{ "admin-dashboard" | translate }}</p>
            <p class="tw-w-full md:tw-min-h-24 md:tw-max-h-24 tw-font-poppins tw-font-normal tw-text-sm md:tw-text-base tw-text-white/50 tw-text-center">
              {{ "admin-dashboard-text-1" | translate }}
            </p>
          </div>
          <div class="tw-w-full md:tw-w-fit tw-h-fit md:tw-max-w-[30%] tw-flex tw-flex-col tw-items-center">
            <img class="tw-w-12 tw-h-12 tw-object-contain tw-mb-5" src="../../../assets/delivery-mobile-app-icon.svg" />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm md:tw-text-lg tw-text-white tw-text-center tw-mb-5">{{ "delivery-mobile-app" | translate }}</p>
            <p class="tw-w-full md:tw-min-h-24 md:tw-max-h-24 tw-font-poppins tw-font-normal tw-text-sm md:tw-text-base tw-text-white/50 tw-text-center">
              {{ "delivery-mobile-app-text-1" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div id="pricing" class="tw-w-full tw-h-fit tw-px-8 md:tw-px-16 tw-py-16 md:tw-py-32">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs md:tw-text-base tw-text-primary tw-text-center tw-mb-5">{{ "pricing" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-secondary tw-text-center tw-mb-10">{{ "pricing-text-1" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-base md:tw-text-xl tw-text-tertiary tw-text-center md:tw-px-[30%] tw-mb-10">
          {{ "pricing-text-2" | translate }}
        </p>
        <div class="tw-w-full tw-h-fit tw-flex tw-justify-center tw-items-center">
          <div class="tw-w-fit tw-h-fit tw-flex max-md:tw-flex-col tw-justify-center tw-items-stretch tw-border tw-border-grey-600 tw-rounded-[10px] tw-overflow-hidden">
            <div *ngFor="let plan of plans" class="pricing-plan">
              <img class="pricing-plan-icon" src="../../../assets/pricing-plan-icon.svg" />
              <img class="pricing-plan-icon-hover" src="../../../assets/pricing-plan-icon-hover.svg" />
              <p class="pricing-plan-title">{{ plan.title | translate }}</p>
              <p class="pricing-plan-description">
                {{ plan.description | translate }}
              </p>
              <p class="pricing-plan-price">{{ plan.price | translate }}</p>
              <p class="pricing-plan-price-time">{{ plan.priceTime | translate }}</p>
              <div class="tw-w-full tw-h-fit tw-mb-10">
                <div *ngFor="let feature of plan.features" class="tw-w-full tw-h-fit">
                  <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-2 tw-mb-4">
                    <div class="pricing-plan-feature-circle-active tw-min-w-5 tw-max-w-5 tw-min-h-5 tw-max-h-5 tw-flex tw-justify-center tw-items-center tw-rounded-full">
                      <img class="pricing-plan-feature-tick-icon" src="../../../assets/feature-tick-icon.svg" />
                      <img class="pricing-plan-feature-tick-icon-hover" src="../../../assets/feature-tick-icon-hover.svg" />
                    </div>
                    <p class="pricing-plan-feature-text-active tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm">
                      {{ feature | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="tw-grow"></div>
              <button (click)="goToRegisterWithPlan(plan.id)" class="pricing-plan-button">{{ "try-right-now" | translate }}</button>
            </div>
          </div>
        </div>
      </div>

      <div id="contact-us" class="tw-w-full tw-h-fit tw-bg-secondary 2xl:tw-rounded-[10px] tw-px-8 md:tw-px-16 tw-py-16 md:tw-py-32">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs md:tw-text-base tw-text-white tw-text-center tw-mb-5">{{ "contact-us" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-white tw-text-center tw-mb-10">{{ "contact-us-text-1" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-base md:tw-text-xl tw-text-white/50 tw-text-center md:tw-px-[30%] tw-mb-10">
          {{ "contact-us-text-2" | translate }}
        </p>
        <div class="tw-w-full tw-h-fit tw-flex tw-justify-center tw-items-center">
          <div class="tw-w-full tw-h-fit md:tw-max-w-80">
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "firstname-lastname" | translate }}</p>
            <input
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
              type="text"
              [(ngModel)]="fullname"
              (change)="setFullname($event)"
              placeholder="{{ 'firstname-lastname' | translate }}"
            />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "email" | translate }}</p>
            <input
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
              type="email"
              [(ngModel)]="email"
              (change)="setEmail($event)"
              placeholder="{{ 'email-placeholder' | translate }}"
            />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "subject" | translate }}</p>
            <input
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
              type="text"
              [(ngModel)]="subject"
              (change)="setSubject($event)"
              placeholder="{{ 'subject' | translate }}"
            />
            <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "message" | translate }}</p>
            <textarea
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
              type="text"
              [(ngModel)]="message"
              (change)="setMessage($event)"
              placeholder="{{ 'message' | translate }}"
            ></textarea>
            <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
              {{ isErrorText | translate }}
            </p>
            <button (click)="sendContactForm()" class="tw-w-full tw-h-fit tw-bg-primary tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-4">
              {{ "send" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div id="faq" class="tw-w-full tw-h-fit tw-px-8 md:tw-px-16 tw-py-16 md:tw-py-32">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xs md:tw-text-base tw-text-primary tw-text-center tw-mb-5">{{ "faq" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-secondary tw-text-center tw-mb-10">{{ "faq-text-1" | translate }}</p>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-base md:tw-text-xl tw-text-tertiary tw-text-center md:tw-px-[30%] tw-mb-10">
          {{ "faq-text-2" | translate }}
        </p>
        <div class="tw-w-full tw-h-fit tw-grid md:tw-grid-cols-2 tw-gap-x-10 tw-gap-y-5">
          <div
            (click)="openFaq(faq)"
            *ngFor="let faq of faqs"
            [ngClass]="faq.open ? '' : ' tw-max-h-20 '"
            class="tw-bg-white tw-border tw-border-grey-600 tw-rounded-[10px] tw-gap-3 tw-px-4 tw-py-3 tw-cursor-pointer tw-transition-colors hover:tw-border-primary"
          >
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-3">
              <p class="tw-flex-1 tw-min-h-14 tw-max-h-14 tw-flex tw-items-center tw-text-secondary tw-font-poppins tw-font-medium tw-text-sm md:tw-text-lg tw-overflow-hidden tw-text-ellipsis">
                {{ faq.question | translate }}
              </p>
              <div class="tw-w-10 tw-h-10 tw-min-w-10 tw-bg-primary/15 tw-flex tw-justify-center tw-items-center tw-rounded-full tw-transition-transform" [ngClass]="faq.open ? 'tw-rotate-90' : ''">
                <img class="tw-w-7 tw-h-7 tw-object-contain" src="../../../assets/arrow-right-dark.svg" />
              </div>
            </div>
            <div *ngIf="faq.open" class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-my-3"></div>
            <p *ngIf="faq.open" class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-xs md:tw-text-base tw-text-secondary">
              {{ faq.answer | translate }}
            </p>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="tw-w-full tw-h-fit tw-bg-secondary 2xl:tw-rounded-[10px] tw-px-8 md:tw-px-16 tw-py-4 md:tw-pt-10 !tw-z-[3]">
        <div class="tw-w-full tw-flex max-md:tw-flex-col tw-justify-between tw-gap-10 md:tw-mb-10">
          <div class="tw-w-full md:tw-max-w-xs tw-flex tw-flex-col tw-gap-4">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
            <p class="tw-font-poppins tw-text-xs tw-text-white/50">{{ "home-description" | translate }}</p>
            <div class="tw-flex tw-items-center tw-gap-4">
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('instagram')" src="../../../assets/footer-instagram-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('facebook')" src="../../../assets/footer-facebook-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('tiktok')" src="../../../assets/footer-tiktok-icon.svg" />
            </div>
          </div>

          <div class="tw-flex tw-gap-16 max-md:tw-gap-10">
            <div class="tw-flex tw-flex-col tw-gap-3">
              <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/40 tw-uppercase tw-tracking-wider">{{ "legal" | translate }}</p>
              <p (click)="goToPrivacyPolicy()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "privacy-policy" | translate }}</p>
              <p (click)="goToTermsOfService()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "terms-of-service" | translate }}</p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-fit">
            <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/50 tw-mb-4">{{ "create-an-account-footer-label" | translate }}</p>
            <button (click)="goToRegister()" class="tw-w-full md:tw-min-w-[150px] tw-bg-primary tw-font-poppins tw-font-semibold tw-text-xs tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-3">
              {{ "create-a-business-account" | translate }}
            </button>
          </div>
        </div>

        <div class="tw-w-full tw-h-px tw-bg-white/10 tw-my-6"></div>

        <p class="tw-font-poppins tw-text-xs tw-text-white/40 tw-text-center">{{ "copyright" | translate }}</p>
      </div>
      <div class="tw-w-full tw-h-5 max-2xl:tw-hidden"></div>
    </div>
  </div>
</div>
